import { Link } from "react-router-dom";
import { categories } from "@/mocks/manhwa";

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索漫画分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            八大分类覆盖各类题材，找到最适合你的韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-lg p-5 md:p-6 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}